import React, { useContext, useState, useRef, useEffect } from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faBars } from '@fortawesome/free-solid-svg-icons';

import AuthContext from 'app/src/contexts/AuthContext';

import ClickOutside from '../elements/ClickListenerMobile';
import Modal from '../elements/Modal';
import NewSale from './Sales/new';
import Settings from './Settings';
import ResetLinks from './ResetLinks';

import * as colors from '../styles/colors';
import AccountMenu from './account/Menu';
import Notifications from './Notifications';
import { HR, RightContainer } from '../elements';
import { createPortal } from 'react-dom';
import UserContext from '../contexts/UserContext';

const MobileContainer = styled(View)`
  display: flex;
  height: 100vh;
  top: 0;
  padding-top: 10px;
  margin-top: 70px;
  right: 0;
  z-index: 10;
  width: 30%;
  border-radius: 5px;
  position: absolute;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 5%;
  padding-right: 5%;
  background-color: ${colors.elLightGray};
  color: #000;
  @media (max-width: 480px) {
    > img {
      width: 90%;
    }
  }
`;

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  z-index: 11;
  padding-top: 20px;
  padding-bottom: 200px;
  overflow: scroll;
  gap: 30px;
`;

const NavBarSection = styled(View)`
  min-height: 18px;
  z-index: 10000;
`;

const NavBarLinkContainer = styled(View)`
  position: absolute;
  display: flex;
  justify-content: column;
  border: 1px solid red;
  padding: 20px;
  background-color: #fff;
  width: 200px !important;
  border-radius: 5px;
  z-index: 10001;
`;

const NavBarLink = styled(View)`
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 20002;
`;

const HeaderMobileNavigation = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { user, hasPolicy } = useContext(AuthContext);
  const { screenWidth } = useContext(UserContext);
  const [currentExploded, setCurrentExploded] = useState();
  const [showAddSaleModal, setShowAddSaleModal] = useState();
  const [showSettingsModal, setShowSettingsModal] = useState();
  const [showResetLinksModal, setShowResetLinksModal] = useState();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [currentMobileContainer, setCurrentMobileContainer] = useState();
  const [currentExplodedContainer, setCurrentExplodedContainer] = useState();
  const mobileContainerRef = useRef();
  const assetsContainerRef = useRef();
  const salesContainerRef = useRef();
  const accountingContainerRef = useRef();
  const adminContainerRef = useRef();
  const userContainerRef = useRef();

  const collapse = () => {
    setCurrentExploded('');
    setShowMobileMenu(false);
  }

  const getExplodedContainer = () => {
    let currentRef;

    switch(currentExploded) {
      case 'assets':
        currentRef = assetsContainerRef;
        break;
      case 'sales':
        currentRef = salesContainerRef;
        break;
      case 'accounting':
        currentRef = accountingContainerRef;
        break;
      case 'admin':
        currentRef = adminContainerRef;
      case 'user':
        currentRef = userContainerRef;
      default:
        break;
    }
    return currentRef?.current
  }

  useEffect(() => {

    if(currentExploded !== '') {
      setCurrentExplodedContainer(getExplodedContainer())
    }
  }, [currentExploded])

  const getPosition = (container) => {
    let currentRef;

    switch(container) {
      case 'assets':
        currentRef = assetsContainerRef;
        break;
      case 'sales':
        currentRef = salesContainerRef;
        break;
      case 'accounting':
        currentRef = accountingContainerRef;
        break;
      case 'admin':
        currentRef = adminContainerRef;
        break;
      case 'user':
        currentRef = userContainerRef;
        break;
      default:
        break;
    }

    return {
      left: currentRef?.current?.getBoundingClientRect()?.x -
        (mobileContainerRef?.current?.getBoundingClientRect().width * 0.95) || 0,
      top: currentRef?.current?.getBoundingClientRect()?.y / 2 || 0,
      zIndex: 999999
    }
  }

  return (
    <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '20px'}}>

      {/* <ClickOutside
        onClick={() => {
          setCurrentExploded('');
          setShowMobileMenu(false);
        }}
        className={'header-navigation-links'}
      > */}
        {user && <Notifications user={user} />}
        <div style={{justifySelf: 'flex-end'}}>
          <FontAwesomeIcon
            icon={faBars}
            size='2x'
            style={{color: '#000', alignSelf: 'flex-end', cursor: 'pointer',
              zIndex: 100000, marginLeft: '20px'
            }}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          />
        </div>
        {showMobileMenu ?
          createPortal(
            <MobileContainer ref={mobileContainerRef}>
              <ClickOutside
                onClick={() => {
                  setCurrentExploded('');
                  setShowMobileMenu(false);
                }}
                className={'header-navigation-links'}
                mobileContainer={currentMobileContainer}
                explodedContainer={currentExplodedContainer}
              >

                <NavbarContainer>
                  {hasPolicy({ type: 'Seller', action: 'index' }) && (
                    <NavBarSection>
                      <Link to={`/sellers`} onClick={collapse}>
                        <Text>Sellers</Text>
                      </Link>
                    </NavBarSection>
                  )}
                  {hasPolicy({ type: 'Asset', action: 'index' }) && (
                    <NavBarSection ref={assetsContainerRef}>
                      <Pressable
                        onPress={() => setCurrentExploded(
                          currentExploded === 'assets' ? '' : 'assets'
                        )}
                      >
                        <Text>Assets</Text>
                      </Pressable>
                      {currentExploded === 'assets' &&
                        createPortal(
                          <NavBarLinkContainer
                            id='assets-links'
                            style={getPosition('sales')}
                          >
                            <NavBarLink>
                              <Link to="/assets" onClick={collapse}>
                                <Text id='sub-link'>Search Assets</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to={`/assetsImport`}
                                onClick={collapse}
                              >
                                <Text id='sub-link'>Import Assets</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/title-logs" onClick={collapse}>
                                <Text id='sub-link'>Title Logs</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/releases" onClick={collapse}>
                                <Text id='sub-link'>Releases</Text>
                              </Link>
                            </NavBarLink>
                          </NavBarLinkContainer>, document.body
                        )
                      }
                    </NavBarSection>
                  )}
                  {hasPolicy({ type: 'Sale', action: 'index' }) && (
                    <NavBarSection ref={salesContainerRef}>
                      <Pressable
                        onPress={() => setCurrentExploded(
                          currentExploded === 'sales' ? '' : 'sales'
                        )}
                      >
                        <Text>Sales</Text>
                      </Pressable>
                      {currentExploded === 'sales' &&
                        createPortal(
                          <NavBarLinkContainer
                            style={getPosition('sales')}
                          >
                            <NavBarLink>
                              <Link to={`/sales`} onClick={collapse}>
                                <Text id='sub-link'>View Sales</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Pressable
                                onPress={() => {
                                  setCurrentExploded(true);
                                  setShowAddSaleModal(true);
                                }}
                              >
                                <Text id='sub-link'>Add a New Sale</Text>
                              </Pressable>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/sales/recurring-sales" onClick={collapse}>
                                <Text>Recurring Sales</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/sales/1/pre-bids" onClick={collapse}>
                                <Text id='sub-link'>Pre-Bids</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/bidding/buyers/1" onClick={collapse}>
                                <Text id='sub-link'>Buyer Lot Views</Text>
                              </Link>
                            </NavBarLink>
                            <HR />
                            <NavBarLink>
                              <Link to="/buyers" onClick={collapse}>
                                <Text id='sub-link'>Buyers</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/conversations" onClick={collapse}>
                                <Text>Chat Conversations</Text>
                              </Link>
                            </NavBarLink>
                          </NavBarLinkContainer>, document.body
                        )
                      }
                    </NavBarSection>
                  )}
                  {!hasPolicy({ type: 'Sale', action: 'bidding_only' }) && (
                    <NavBarSection>
                      <Link to="/reports">
                        <Text>Reports</Text>
                      </Link>
                    </NavBarSection>
                  )}
                  {user?.accounting && (
                    <NavBarSection ref={accountingContainerRef}>
                      <Pressable
                        onPress={() => setCurrentExploded(
                          currentExploded === 'accounting' ? '' : 'accounting'
                        )}
                      >
                        <Text>Accounting</Text>
                      </Pressable>
                      {currentExploded === 'accounting' &&
                        createPortal(
                          <NavBarLinkContainer
                            style={getPosition('accounting')}
                          >
                            <NavBarLink>
                              <Link to="/purchase-orders" onClick={collapse}>
                                <Text id='sub-link'>Purchase Orders</Text>
                              </Link>
                            </NavBarLink>
                            {user?.accounting &&
                              <>
                                <NavBarLink>
                                  <Link to="/accounts-payable" onClick={collapse}>
                                    <Text id='sub-link'>Accounts Payable</Text>
                                  </Link>
                                </NavBarLink>
                                {/*
                                  <NavBarLink>
                                    <Link
                                      to="/accounts-receivable"
                                      onClick={collapse}
                                    >
                                      <Text>Accounts Receivable</Text>
                                    </Link>
                                  </NavBarLink>
                                */}
                                <HR />
                                <NavBarLink>
                                  <Link
                                    to={`/pending-paddle-service-payments`}
                                    onClick={collapse}
                                  >
                                    <Text id='sub-link'>Pending Paddle Service Payments</Text>
                                  </Link>
                                </NavBarLink>
                                <NavBarLink>
                                  <Link
                                    to={`/paddle-service-payment-tracking`}
                                    onClick={collapse}
                                  >
                                    <Text id='sub-link'>Paddle Service Payment Tracking</Text>
                                  </Link>
                                </NavBarLink>
                                <HR />
                                <NavBarLink>
                                  <Link
                                    to={`/vendors`}
                                    onClick={collapse}
                                  >
                                    <Text id='sub-link'>Vendors</Text>
                                  </Link>
                                </NavBarLink>
                              </>
                            }
                          </NavBarLinkContainer>, document.body
                        )
                      }
                    </NavBarSection>
                  )}
                  {user?.admin &&
                    <NavBarSection ref={adminContainerRef}>
                      <Pressable
                        onPress={() => setCurrentExploded('admin')}
                      >
                        <Text>Admin</Text>
                      </Pressable>
                      {currentExploded === 'admin' &&
                        createPortal(
                          <NavBarLinkContainer
                            style={getPosition('admin')}
                          >
                            <NavBarLink>
                              <Link to={`/users`} onClick={collapse}>
                                <Text id='sub-link'>Users</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to={`/locations`} onClick={collapse}>
                                <Text id='sub-link'>Locations</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Pressable
                                onPress={() => setShowSettingsModal(true)}
                              >
                                <Text id='sub-link'>Settings</Text>
                              </Pressable>
                            </NavBarLink>
                            <NavBarLink>
                              <Pressable
                                onPress={() => setShowResetLinksModal(true)}
                              >
                                <Text id='sub-link'>Password Resets</Text>
                              </Pressable>
                            </NavBarLink>
                            <HR />
                            {user?.canAccessCommissions &&
                              <View>
                                <NavBarLink>
                                  <Link
                                    to="/commissions-and-salespeople"
                                    onClick={collapse}
                                  >
                                    <Text id='sub-link'>Commission Structures and Salespeople</Text>
                                  </Link>
                                </NavBarLink>
                                <HR />
                              </View>
                            }
                            <NavBarLink>
                              <Link to={`/paddle-services`} onClick={collapse}>
                                <Text id='sub-link'>Paddle Services</Text>
                              </Link>
                            </NavBarLink>
                            <NavBarLink>
                              <Link to="/pre-bid-schedules" onClick={collapse}>
                                <Text id='sub-link'>Pre-Bid Pricing Schedules</Text>
                              </Link>
                            </NavBarLink>
                            <HR />
                            <NavBarLink>
                              <Link to={`/inactive-resources`} onClick={collapse}>
                                <Text id='sub-link'>Inactive Resources</Text>
                              </Link>
                            </NavBarLink>
                            <HR />
                            <NavBarLink>
                              <Link to={`/blog`} onClick={collapse}>
                                <Text id='sub-link'>Blog</Text>
                              </Link>
                            </NavBarLink>
                          </NavBarLinkContainer>, document.body
                        )
                      }
                    </NavBarSection>
                  }
                  <FontAwesomeIcon
                    icon={faCircleUser}
                    size='2xl'
                    style={{color: colors.elRed}}
                    onClick={() => {
                      setShowMenu(!showMenu);
                      setCurrentExploded('user');
                    }}
                  />
                  <AccountMenu
                    showMenu={showMenu}
                    setShowMenu={setShowMenu}
                    ref={userContainerRef}
                  />
                </NavbarContainer>
              </ClickOutside>
            </MobileContainer>, document.body
          ) :
          null
        }
        {showAddSaleModal &&
          <Modal
            showModal={showAddSaleModal}
            setShowModal={setShowAddSaleModal}
            modalType={'Add Sale'}
          >
            <NewSale
              setShowModal={setShowAddSaleModal}
              fromNav={true}
            />
          </Modal>
        }
        {showSettingsModal &&
          <Modal
            showModal={showSettingsModal}
            setShowModal={setShowSettingsModal}
            modalType={'Update Settings'}
          >
            <Settings
              setShowModal={setShowSettingsModal}
              fromNav={true}
            />
          </Modal>
        }
        {showResetLinksModal &&
          <Modal
            showModal={showResetLinksModal}
            setShowModal={setShowResetLinksModal}
            modalType={'Get Password Reset Link'}
          >
            <ResetLinks setShowModal={setShowResetLinksModal} />
          </Modal>
        }
      {/* </ClickOutside> */}
    </div>
  )
};

export default HeaderMobileNavigation;
